import type { FC } from 'react';
import { AiFillInstagram } from 'react-icons/ai';
import { CgFacebook } from 'react-icons/cg';
import * as Styled from './components';

export const SocialsSideButtons: FC = () => {
  return (
    <Styled.Wrapper>
      <Styled.SocialButton
        type="facebook"
        href="https://www.facebook.com/tipawdogs/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <CgFacebook />
      </Styled.SocialButton>
      <Styled.SocialButton
        type="instagram"
        href="https://www.instagram.com/tipawdogs/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiFillInstagram />
      </Styled.SocialButton>
    </Styled.Wrapper>
  );
};
